import React from 'react';
import { motion } from 'framer-motion';

const Store = () => {
  return (
    <div className="min-h-[80vh] flex items-center justify-center to-white">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center p-8"
      >
        <motion.div
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-8"
        >
          <span className="text-6xl">🛍️</span>
        </motion.div>
        
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          Store Coming Soon
        </h1>
        
        <p className="text-xl text-gray-600 mb-8 max-w-md mx-auto">
          We're working hard to bring you an amazing shopping experience. Stay tuned for updates!
        </p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="flex flex-col items-center space-y-4"
        >
          <div className="flex space-x-2">
            <div className="w-3 h-3 bg-yellow-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-3 h-3 bg-yellow-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-3 h-3 bg-yellow-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
          {/*<p className="text-sm text-gray-500">
            Expected launch: Q2 2024
          </p>*/}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Store;
